import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import EditableListTab from 'components/editable-list-tab';
import st from 'core/shared-translations';

const t = defineMessages({
  'client-edit.field.requiredScopes': {
    id: 'client-edit.field.requiredScopes',
    defaultMessage: 'Required scope ID',
    description: 'Label for the Required Scope ID field',
  },
  'client-edit.field.requiredScopes.placeholder': {
    id: 'client-edit.field.requiredScopes.placeholder',
    defaultMessage: 'Enter required scope ID',
    description: 'Placeholder for the Required Scope ID field',
  },
});

const ClientRequiredScopesTab = ({
  client,
  canWrite,
  requiredScopes = [],
  onAddRequiredScope,
  onDeleteRequiredScope,
  scopeValidationErrors,
  clearScopeError
}) => {
  const translations = {
    fieldLabel: t['client-edit.field.requiredScopes'],
    fieldPlaceholder: t['client-edit.field.requiredScopes.placeholder'],
    addButtonText: st['shared.add']
  };

  return (
    <EditableListTab
      client={client}
      canWrite={canWrite}
      items={requiredScopes}
      onAddItem={onAddRequiredScope}
      onDeleteItem={onDeleteRequiredScope}
      translations={translations}
      validationErrors={scopeValidationErrors}
      clearScopeError={clearScopeError}
    />
  );
};

ClientRequiredScopesTab.propTypes = {
  client: PropTypes.object.isRequired,
  canWrite: PropTypes.bool,
  requiredScopes: PropTypes.array,
  onAddRequiredScope: PropTypes.func.isRequired,
  onDeleteRequiredScope: PropTypes.func.isRequired,
  scopeValidationErrors: PropTypes.string,
  clearScopeError: PropTypes.func.isRequired,
};

export default ClientRequiredScopesTab;